// Invoices.jsx
import React, { Component } from "react";
import { LuDownload } from "react-icons/lu";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../../shared/components/Loading/Loading";
import moment from "moment";
import "../Product/Create.css";
import "./Invoices.css";
import "moment/locale/pt-br";

import requestApi from "../../../apirest";

import InvoicesFilter from "./InvoicesFilter";
import InvoicesTable from "./InvoicesTable";
import ViewInvoiceModal from "./ViewInvoiceModal";
import DeleteInvoiceModal from "./DeleteInvoiceModal";
import EditInvoiceModal from "./EditInvoiceModal";

import InvoicesXls from "./../InvoicesXls";
import SalesKpiRow from "./SalesKpiRow";
import SalesDashboardSection from "./SalesDashboardSection";
import RevenueChart from "./RevenueChart";
import SalesChannelsChart from "./SalesChannelsChart";
import TopProductsList from "./TopProductsList";
import {
  computeKpis,
  filterByChannel,
  revenueByPeriod,
  salesByChannel,
  topProducts,
} from "./salesMetrics";
import {
  PaymentScheduleModal,
  savePaymentSchedule,
} from "../../../features/paymentSchedule";

moment.locale("pt-br");

class Invoices extends Component {
  state = {
    modal: false,
    modalEdit: false,
    modalDelete: false,
    orders: [],
    initialOrders: [],
    searchProduct: "",
    invoiceview: null,
    invoiceDelete: null,
    invoiceEdit: null,
    start: "",
    end: "",
    selectedType: "Todos",
    selectedTypeDelivery: "Todos",
    selectedChannel: "Todos",
    // Período da última busca aplicada — o gráfico usa este, não o que
    // está sendo digitado nos campos de data (digitar o ano passa por
    // valores tipo "0002-10-01" e travava a tela).
    appliedStart: "",
    appliedEnd: "",
    loading: false,
    statusMotoboy: "",
    codeTracking: "",
    productCosts: {},
    paymentOrder: null,
    savingPayment: false,
    chartGranularity: "daily",
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.findOrderList(); // primeira busca (últimos 6 meses)
    this.loadProductCosts();
  }

  /** Custo total por produto (para a coluna de Lucro Real da tabela) */
  loadProductCosts = async () => {
    try {
      const resp = await requestApi(`/totalCost`, {}, "get");
      const productCosts = {};
      (resp?.data?.doc || []).forEach((doc) => {
        if (doc.product && productCosts[doc.product] === undefined) {
          productCosts[doc.product] = doc.price;
        }
      });
      this.setState({ productCosts });
    } catch {
      /* silente — coluna de lucro só mostra "—" se não achar custo */
    }
  };

  /**
   * Busca lista de pedidos
   */
  findOrderList = async () => {
    this.setState({ loading: true });

    try {
      let {
        start,
        end,
        searchProduct,
        selectedType,
        selectedTypeDelivery,
        selectedChannel,
      } = this.state;

      // Se ainda não tem data, define os últimos 6 meses (primeiro load)
      if (!start || !end) {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 6);

        start = startDate.toISOString().split("T")[0];
        end = endDate.toISOString().split("T")[0];

        this.setState({ start, end });
      }

      const params = { start, end };

      if (searchProduct && searchProduct.trim()) {
        params.customer = searchProduct.trim(); // ajuste para o nome esperado pelo back
      }

      if (selectedType && selectedType !== "Todos") {
        params.status = selectedType;
      }

      if (selectedTypeDelivery && selectedTypeDelivery !== "Todos") {
        params.deliveryType = selectedTypeDelivery;
      }

      const resp = await requestApi(`/order`, params, "get", "order");

      // Canal (presencial/online) é filtrado aqui — o back não tem esse filtro
      const orders = filterByChannel(resp?.data?.doc || [], selectedChannel);

      toast.success("As informações foram carregadas com sucesso.", {
        autoClose: 4000,
      });

      this.setState({
        loading: false,
        orders,
        initialOrders: orders,
        appliedStart: start,
        appliedEnd: end,
      });
    } catch (error) {
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false });
    }
  };

  /** FILTROS: só setam state, quem consulta é o botão Buscar */
  onSearchProduct = (searchText) => {
    this.setState({ searchProduct: searchText });
  };

  onSearchProductByStatus = (status) => {
    this.setState({ selectedType: status });
  };

  onSearchProductByDelivery = (deliveryType) => {
    this.setState({ selectedTypeDelivery: deliveryType });
  };

  /** Limpa os campos de filtro (a busca continua sendo no "Aplicar") */
  clearFilters = () => {
    this.setState({
      searchProduct: "",
      selectedType: "Todos",
      selectedTypeDelivery: "Todos",
      selectedChannel: "Todos",
    });
  };

  onChangeChannel = (selectedChannel) => {
    this.setState({ selectedChannel });
  };

  setChartGranularity = (chartGranularity) => {
    this.setState({ chartGranularity });
  };

  /** HANDLERS / MODAIS */
  toggleView = () => {
    this.setState((prev) => ({ modal: !prev.modal }));
  };

  toggleEdit = () => {
    this.setState((prev) => ({ modalEdit: !prev.modalEdit }));
  };

  toggleDelete = () => {
    this.setState((prev) => ({ modalDelete: !prev.modalDelete }));
  };

  setStartDate = (start) => {
    this.setState({ start });
  };

  setEndDate = (end) => {
    this.setState({ end });
  };

  handleStatusMotoboy = (e) => {
    const { value } = e.target;
    this.setState({ statusMotoboy: value });
  };

  handleTracking = (e) => {
    const { value } = e.target;
    this.setState({ codeTracking: value });
  };

  onViewInvoicePopup = (data) => {
    this.setState({ invoiceview: data }, this.toggleView);
  };

  onDeletePopup = (data) => {
    this.setState({ invoiceDelete: data }, this.toggleDelete);
  };

  onEditOrderManually = (data) => {
    this.props.history.push({
      pathname: `/admin-panel/venda-balcao/editar/${data._id}`,
      state: { order: data },
    });
  };

  onEditInvoicePopup = (data) => {
    this.setState(
      {
        invoiceEdit: data,
        statusMotoboy: "",
        codeTracking: "",
      },
      this.toggleEdit,
    );
  };

  /** FINANCEIRO (parcelas) */
  onPaymentPopup = (data) => {
    this.setState({ paymentOrder: data });
  };

  closePayment = () => {
    this.setState({ paymentOrder: null });
  };

  savePayment = async (schedule) => {
    const { paymentOrder } = this.state;
    if (!paymentOrder?._id) return;

    this.setState({ savingPayment: true });
    try {
      const updated = await savePaymentSchedule(paymentOrder._id, schedule);

      // Atualiza só a linha alterada, sem refazer a busca inteira
      const patch = (list) =>
        list.map((o) =>
          o._id === updated._id
            ? {
                ...o,
                status: updated.status,
                paidAmount: updated.paidAmount,
                installments: updated.installments,
                paymentSchedule: updated.paymentSchedule,
              }
            : o,
        );

      this.setState((prev) => ({
        orders: patch(prev.orders),
        initialOrders: patch(prev.initialOrders),
        paymentOrder: null,
        savingPayment: false,
      }));

      toast.success("Parcelas salvas com sucesso.", { autoClose: 4000 });
    } catch (error) {
      toast.error("Não foi possível salvar as parcelas.", { autoClose: 4000 });
      this.setState({ savingPayment: false });
    }
  };

  /** STATUS / ENTREGA (mantidos) */
  saveStatusMotoboy = async () => {
    const { invoiceEdit, statusMotoboy } = this.state;

    if (
      !invoiceEdit?.tracking ||
      !["entregue", "saiu"].includes(statusMotoboy)
    ) {
      return;
    }

    try {
      const status_list = invoiceEdit.tracking.status_list || [];
      this.setState({ loading: true });

      const status =
        statusMotoboy === "entregue"
          ? "Entrega finalizada."
          : "Saiu para entrega.";

      const newStatus = {
        data: moment().format("DD/MM/YYYY HH:mm"),
        status,
      };

      status_list.push(newStatus);

      const delivery = {
        _id: invoiceEdit.tracking._id,
        status,
        order: invoiceEdit._id,
        status_list,
      };

      await requestApi(`/delivery`, { delivery }, "patch");

      toast.success("As informações foram atualizadas com sucesso.", {
        autoClose: 4000,
      });

      await this.findOrderList();

      this.setState({ loading: false });
    } catch (error) {
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false });
    }
  };

  saveStatus = async () => {
    const { invoiceEdit, codeTracking } = this.state;

    if (!invoiceEdit?.tracking || !codeTracking) return;
    if (invoiceEdit.tracking.code) return;

    try {
      this.setState({ loading: true });

      const delivery = {
        code: codeTracking,
        _id: invoiceEdit.tracking._id,
        order: invoiceEdit._id,
      };

      await requestApi(`/delivery`, { delivery }, "patch");

      toast.success("As informações foram atualizadas com sucesso.", {
        autoClose: 4000,
      });

      await this.findOrderList();

      this.setState({ loading: false });
    } catch (error) {
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false });
    }
  };

  // Envio comercial vai com a NF-e do Bling. Sem nota autorizada a API
  // responde 409 — aí o admin escolhe se segue como declaração de conteúdo.
  addToCart = async (reverse, withoutInvoice = false) => {
    const { invoiceEdit } = this.state;
    if (!invoiceEdit?._id) return;

    try {
      this.setState({ loading: true });

      await requestApi(
        `/services/melhorEnvio/addToCart`,
        { idOrder: invoiceEdit._id, reverse, withoutInvoice },
        "post",
      );

      toast.success("Foi adicionado no carrinho do Melhor Envio.", {
        autoClose: 4000,
      });

      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      if (error?.response?.data?.code === "MISSING_INVOICE") {
        const proceed = window.confirm(
          "Este pedido ainda não tem NF-e autorizada no Bling.\n\nEmita a nota no painel \"Nota fiscal\" acima, ou clique em OK para gerar a etiqueta mesmo assim como declaração de conteúdo.",
        );
        if (proceed) this.addToCart(reverse, true);
        return;
      }
      toast.error(
        error?.response?.data?.message || "Aconteceu algum erro inesperado.",
        { autoClose: 4000 },
      );
    }
  };

  handleFiscalChange = (fiscal) => {
    this.setState((state) => ({
      invoiceEdit: state.invoiceEdit ? { ...state.invoiceEdit, fiscal } : state.invoiceEdit,
    }));
  };

  deleteProduct = async () => {
    const { invoiceDelete } = this.state;
    if (!invoiceDelete) return;

    this.setState({ loading: true });

    try {
      await requestApi(`/order/delete`, { order: invoiceDelete }, "post");

      this.setState({ loading: false });

      this.toggleDelete();
      this.findOrderList();
    } catch (error) {
      console.log(error);
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false });
    }
  };

  gerarBoletoUrl = () => {
    const { invoiceview } = this.state;
    if (invoiceview?.boleto_url) {
      window.open(invoiceview.boleto_url, "_blank");
    } else {
      toast.error("Não foi possível gerar o boleto.", {
        autoClose: 4000,
      });
    }
  };

  render() {
    const {
      loading,
      invoiceEdit,
      invoiceview,
      start,
      end,
      searchProduct,
      selectedType,
      selectedTypeDelivery,
      selectedChannel,
      orders,
      initialOrders,
      modal,
      modalEdit,
      modalDelete,
      statusMotoboy,
      codeTracking,
      productCosts,
      paymentOrder,
      savingPayment,
      chartGranularity,
      appliedStart,
      appliedEnd,
    } = this.state;

    const kpis = computeKpis(initialOrders, productCosts);

    const handleSaveEdit = () => {
      if (invoiceEdit?.tracking?.type === "motoboy") {
        this.saveStatusMotoboy();
      } else {
        this.saveStatus();
      }
    };

    return (
      <div className="cp-page sales-page">
        <ToastContainer />

        <div className="cp-topbar sales-page__topbar">
          <div>
            <h1 className="cp-topbar-title">Vendas</h1>
            <p className="sales-page__subtitle">
              Acompanhe o desempenho das vendas da sua operação.
            </p>
          </div>
          <div className="cp-topbar-actions">
            {initialOrders && initialOrders.length > 0 && (
              <InvoicesXls
                invoices={initialOrders}
                className="cp-btn cp-btn--primary sales-page__export"
              >
                <LuDownload size={16} />
                Exportar
              </InvoicesXls>
            )}
          </div>
        </div>

        <div className="sales-page__grid">
          <InvoicesFilter
            start={start}
            end={end}
            searchProduct={searchProduct}
            selectedType={selectedType}
            selectedTypeDelivery={selectedTypeDelivery}
            selectedChannel={selectedChannel}
            onChangeStartDate={this.setStartDate}
            onChangeEndDate={this.setEndDate}
            onSearchProduct={this.onSearchProduct}
            onSearchProductByStatus={this.onSearchProductByStatus}
            onSearchProductByDelivery={this.onSearchProductByDelivery}
            onChangeChannel={this.onChangeChannel}
            onSubmitFilters={this.findOrderList}
            onClear={this.clearFilters}
          />

          <div className="sales-page__main">
            <SalesDashboardSection>
              <SalesKpiRow kpis={kpis} />
              <div className="sales-page__charts">
                <RevenueChart
                  data={revenueByPeriod(
                    initialOrders,
                    chartGranularity,
                    appliedStart,
                    appliedEnd,
                  )}
                  granularity={chartGranularity}
                  onGranularityChange={this.setChartGranularity}
                />
                <SalesChannelsChart data={salesByChannel(initialOrders)} />
                <TopProductsList items={topProducts(initialOrders, 10)} />
              </div>
            </SalesDashboardSection>
          </div>
        </div>

        {/* Pedidos: fora da grade de cima, largura total da página */}
        <InvoicesTable
          data={orders || []}
          productCosts={productCosts}
          onView={this.onViewInvoicePopup}
          onEdit={this.onEditInvoicePopup}
          onEditOrderManually={this.onEditOrderManually}
          onDelete={this.onDeletePopup}
          onPayment={this.onPaymentPopup}
        />

        {/* MODAIS */}
        <ViewInvoiceModal
          isOpen={modal}
          toggle={this.toggleView}
          order={invoiceview}
          gerarBoletoUrl={this.gerarBoletoUrl}
        />

        <DeleteInvoiceModal
          isOpen={modalDelete}
          toggle={this.toggleDelete}
          onConfirm={this.deleteProduct}
        />

        <PaymentScheduleModal
          isOpen={Boolean(paymentOrder)}
          order={paymentOrder}
          saving={savingPayment}
          onClose={this.closePayment}
          onSave={this.savePayment}
        />

        <EditInvoiceModal
          isOpen={modalEdit}
          toggle={this.toggleEdit}
          invoiceEdit={invoiceEdit}
          statusMotoboy={statusMotoboy}
          onChangeStatusMotoboy={this.handleStatusMotoboy}
          codeTracking={codeTracking}
          onChangeTrackingCode={this.handleTracking}
          onSave={handleSaveEdit}
          onAddToCart={this.addToCart}
          onFiscalChange={this.handleFiscalChange}
        />

        {loading && <Loading overlay />}
      </div>
    );
  }
}

export default Invoices;
